/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_ParticipantInvestmentExperienceDto } from '../models/PagedResultDto_ParticipantInvestmentExperienceDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantInvestmentExperience_CreateUpdateParticipantInvestmentExperienceDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantInvestmentExperience_CreateUpdateParticipantInvestmentExperienceDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantInvestmentExperience_ParticipantInvestmentExperienceDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantInvestmentExperience_ParticipantInvestmentExperienceDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantInvestmentExperienceService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_ParticipantInvestmentExperience_ParticipantInvestmentExperienceDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantInvestmentExperienceParticipantInvestmentExperiencesList(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_ParticipantInvestmentExperience_ParticipantInvestmentExperienceDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-investment-experience/participant-investment-experiences-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_ParticipantInvestmentExperience_ParticipantInvestmentExperienceDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppParticipantInvestmentExperience(
requestBody?: Wealthlane_CustomerService_Dtos_ParticipantInvestmentExperience_CreateUpdateParticipantInvestmentExperienceDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantInvestmentExperience_ParticipantInvestmentExperienceDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/participant-investment-experience',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_ParticipantInvestmentExperienceDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantInvestmentExperience(
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_ParticipantInvestmentExperienceDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-investment-experience',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_ParticipantInvestmentExperience_ParticipantInvestmentExperienceDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppParticipantInvestmentExperience(
id: string,
requestBody?: Wealthlane_CustomerService_Dtos_ParticipantInvestmentExperience_CreateUpdateParticipantInvestmentExperienceDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantInvestmentExperience_ParticipantInvestmentExperienceDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/participant-investment-experience/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppParticipantInvestmentExperience(
id: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/participant-investment-experience/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_CustomerService_Dtos_ParticipantInvestmentExperience_ParticipantInvestmentExperienceDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantInvestmentExperience1(
id: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantInvestmentExperience_ParticipantInvestmentExperienceDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-investment-experience/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
